var map = {
	"./dzen-green.svg": "a4b2",
	"./email-green.svg": "7ef6",
	"./phone-green.svg": "66ca",
	"./telegram-green.svg": "b257",
	"./vk-green.svg": "9416",
	"./youtube-green.svg": "ce8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb27";